import React from "react";

// The figure at the right of a filter row. Almanac gives a cheapest-in-bucket price for the filters
// where it means something (board, airline, rating, transfer class) — "from £499" tells a customer far
// more about a filter than how many hotels sit behind it — and only a count for the rest.
const FilterFigure = ({ option }) => {
    if (option?.fromPrice > 0) {
        return (
            <span className="filter-count">
                from £{Math.round(option.fromPrice).toLocaleString("en-GB")}
            </span>
        );
    }
    if (option?.count > 0) {
        return <span className="filter-count">{option.count}</span>;
    }
    return null;
};

export default FilterFigure;
